import { useStore } from "vuex";
import { computed } from "vue";
import { Applicant } from "@/models/application";

export function useOidcStore() {
  const store = useStore();

  const oidcUser = computed(() => store.getters["oidcStore/oidcUser"]);

  const oidcIsAuthenticated = computed(() => store.getters["oidcStore/oidcIsAuthenticated"]);

  const authenticatedApplicant = computed(() =>
    store.state.appData.applicants.find((a: Applicant) => a.userId === oidcUser?.value?.sub),
  );

  return {
    oidcUser,
    oidcIsAuthenticated,
    authenticatedApplicant,
  };
}
